export const onUpdatePoll = `
  subscription onUpdatePoll($pk: String!) {
    onUpdatePoll(pk: $pk) {
      pk
      currentQuestion
      LSI1SK
      lastAccessed
    }
  }
`;

export const onAddResponseToPoll = `
  subscription onAddResponseToPoll($GSI2PK: String) {
    onAddResponseToPoll(GSI2PK: $GSI2PK) {
      pk
      sk
      GSI2PK
      GSI2SK
      response {
        choiceIndexes
        portalQid
        responseType
        text
        shortAnswerBlanks {
          blankUID
          userAnswer
        }
        userId
      }
    }
  }
`;

export const onDeletePollResponse = `
  subscription onDeletePollResponse($pk: String, $sk: String) {
    onDeletePollResponse(pk: $pk, sk: $sk) {
      pk
      sk
      GSI2PK
      GSI2SK
    }
  }
`;

export const onActivateUserPoll = `
  subscription onActivateUserPoll($pk: String!) {
    onActivateUserPoll(pk: $pk) {
      pk,
      sk,
      LSI1SK
    }
  }
`;


export const onUpdateQuestionStatus = `
  subscription onUpdateQuestionStatus($pk: String!, $sk: String!) {
    onUpdateQuestionStatus(pk: $pk, sk: $sk) {
      pk
      sk
      questionStatus
    }
  }
`;
